import { IMessage } from 'src/interfaces/message';
import { EXTRA_HOT, HOT, WARM, COLD, NONE } from 'src/constants/lead/ratings';

export const MEDIA_CONTENT_DEFAULT = 'default';
export const MEDIA_CONTENT_IMAGE = 'image/webp';
export const MEDIA_CONTENT_PDF = 'application/pdf';

export const LAST_MODIFIED_FILE = 1712982400000;

export const EMPTY_MESSAGE: IMessage = {
    _id: '',
    Body: '',
    Author: '',
    To: '',
    From: '',
    createdAt: new Date(),
    Direction: '',
    MediaUrl0: '',
    MediaContentType0: 'default',
};

export const RATINGS: Record<string, string> = {
    [HOT]: 'error',
    [WARM]: 'warning',
    [COLD]: 'blue',
    [EXTRA_HOT]: 'deepPurple',
    [NONE]: 'primary',
};

export const CURRENT_TEMPLATE_DEFAULT = {
    _id: '',
    title: '',
    description: '',
    templateType: '',
    messageWithoutFormat: '',
    options: {},
};
